import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { JwtHelperService } from '@auth0/angular-jwt';

import { CKPassLoginModel } from '@core/models/interfaces/login.interface';
import { LocalStorageService, keyTriggerSession } from '../common';
import { AuthService } from './auth.service';
import { LOCAL_STORAGE_KEY } from '@core/configs/local-storage-key.config';
import { SaucerLogService } from '@core/services/apis/saucer-log.service';

@Injectable()
export class LoginService {
    jwtHelper = new JwtHelperService();

    constructor(
        public translate: TranslateService,
        private authService: AuthService,
        private localStorageService: LocalStorageService,
        private saucerLogService: SaucerLogService,
    ) { }

    async loginByCKPass(loginData: CKPassLoginModel) {
        const res = await this.authService.loginByCKPass(loginData);
        if (res && res.result) {
            const userSession = {
                accessToken: res.result.accessToken,
                refreshToken: res.result.refreshToken,
            };
            this.localStorageService.setUserSession(userSession);
            const permissions = res.result.permissions;
            this.localStorageService.setItem(LOCAL_STORAGE_KEY.userPermissions, permissions)
            this.localStorageService.trigger(keyTriggerSession.setToken);
            const userId = this.localStorageService.getUserId()
            this.localStorageService.setItem(LOCAL_STORAGE_KEY.userId, userId.toString());
            this.localStorageService.setItem(LOCAL_STORAGE_KEY.handleFirstMenu, false);

            const fullName = this.localStorageService.getFullName();
            localStorage.setItem(LOCAL_STORAGE_KEY.fullName, fullName)
            // Write login log
            this.saucerLogService.logLogin();
            this.authService.setIsLoggedIn(true);
            return true;
        }
    }
}
